import { AuthState } from "hooks/auth";
import { DeployedFile } from "types/qbank/deployedFile";
import { DeploymentSite } from "types/qbank/deploymentSite";

export const getOriginalLink = (
  host: string,
  mediaId: number,
  template: string,
  auth: AuthState
) => {
  return `https://${host}/api/v1/media/${mediaId}/download?template=${template}&access_token=${
    "oAuthToken" in auth ? auth.oAuthToken.access_token : ""
  }`;
};

const formatCacheBust = (date: string) => {
  const d = new Date(date);
  return String(d.getFullYear()) + String(d.getMonth() + 1).padStart(2, '0') + String(d.getDate()).padStart(2, '0')  + String(d.getHours()).padStart(2, '0') + String(d.getMinutes()).padStart(2, '0') + String(d.getSeconds()).padStart(2, '0');
}

export const getPublishUrl = (
  deploymentSite: DeploymentSite,
  deployedFiles: DeployedFile[] | undefined,
  templateId: number
) => {
  const deployedFile = deployedFiles
      ?.find(
        file => file.deploymentSiteId === deploymentSite.id
        && (
          file.imageTemplateId === templateId
          || (isNaN(templateId) && file.metadata.includes('original'))
        )
      );

  const viewServer = removeSlashes(deploymentSite.viewserver);
  const viewPath = removeSlashes(deploymentSite.viewpath);
  const remoteFile = removeSlashes(deployedFile?.remoteFile ?? '');

  return deployedFile
    ? `${viewServer}/${viewPath}/${remoteFile}?v=${formatCacheBust(deployedFile.updated)}`
    : undefined;
};

const removeSlashes = (url: string) => {
  return url.replace(/(^\/+)|(\/+$)/g, '');
}
